import React, { useState } from "react";
import { TextField } from "@mui/material";
import PercentIcon from "@mui/icons-material/Percent";

const FRM_QuoteOrder = (props) => {
  const [customMargin, setCustomMargin] = useState(false);

  const handleChange = (e) => {
    props.setFormData({ ...props.formData, margin: e.target.value });
  };

  const formType = props.formData.form_type || "quote";

  // Segmented-control pill; `tone` colors the selected state.
  const segment = (active, tone = "sky") =>
    `min-h-[2.25rem] rounded-full px-4 text-sm font-medium transition focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-500 ${
      active
        ? tone === "emerald"
          ? "bg-emerald-600 text-white shadow-sm"
          : "bg-sky-600 text-white shadow-sm"
        : "text-[color:var(--app-text)] hover:bg-[color:var(--app-hover)]"
    }`;

  return (
    <div className="app-surface flex flex-wrap items-start gap-x-8 gap-y-4 rounded-xl border p-4">
      {/* Quote / Order toggle */}
      <div>
        <p className="mb-1.5 text-sm font-semibold">Form Type</p>
        <div
          className="app-card inline-flex gap-1 rounded-full border p-1"
          role="group"
          aria-label="Form Type"
        >
          <button
            type="button"
            aria-pressed={formType === "quote"}
            onClick={() =>
              props.setFormData({ ...props.formData, form_type: "quote" })
            }
            className={segment(formType === "quote")}
          >
            Quote
          </button>
          <button
            type="button"
            aria-pressed={formType === "order"}
            onClick={() =>
              props.setFormData({ ...props.formData, form_type: "order" })
            }
            className={segment(formType === "order", "emerald")}
          >
            Order
          </button>
        </div>
      </div>

      {/* Margin adjustment */}
      <div>
        <p className="mb-1.5 text-sm font-semibold">Adjust Default Margin?</p>
        <div className="flex flex-wrap items-center gap-3">
          <div
            className="app-card inline-flex gap-1 rounded-full border p-1"
            role="group"
            aria-label="Adjust Default Margin?"
          >
            <button
              type="button"
              aria-pressed={!customMargin}
              onClick={() => setCustomMargin(false)}
              className={`${segment(!customMargin)} min-w-[3.5rem]`}
            >
              No
            </button>
            <button
              type="button"
              aria-pressed={customMargin}
              onClick={() => setCustomMargin(true)}
              className={`${segment(customMargin)} min-w-[3.5rem]`}
            >
              Yes
            </button>
          </div>
          {customMargin && (
            <TextField
              onChange={handleChange}
              type={"text"}
              size="small"
              className="w-28"
              value={props.formData.margin}
              placeholder="Margin"
              inputProps={{ "aria-label": "Margin" }}
              InputProps={{
                endAdornment: <PercentIcon fontSize="small" />,
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default FRM_QuoteOrder;
